import { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import FixedCTA from "./FixedCTA";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:bg-white focus:text-foreground focus:px-4 focus:py-2 focus:rounded"
      >
        Skip to content
      </a>
      <Header />
      <main id="main-content" className="flex-1 pt-20">{children}</main>
      <Footer />
      <FixedCTA />
    </div>
  );
};

export default Layout;
